/**
 * Lorinzer Living — Product Configurator v8
 * Fixed: addon radio watchers, summary price calculation, mattress state
 * Updated: headboard height variant support added
 */

(function () {
  'use strict';

  var ADDON_PRODUCTS = {
    ottoman_box    : { handle: 'cubex-crushed-velvet-ottoman-box-storage-blanket-box-various-colors' },
    headboard      : { handle: 'vertical-split-headboard-option' },
    assembly       : { handle: 'assembly-service' }   // variant[0] = paid £80
    // assembly free variant fetched dynamically — see llzGetFreeAssemblyVariantId()
  };

  /* --- Free Assembly state ---
   * When free: adds the £0 variant (variant[1]) of Assembly Service product.
   * No Shopify discount needed. No discount tags on any cart items.
   * SETUP REQUIRED: Add a 2nd variant to Assembly Service product in Shopify:
   *   Title: "Free - Included"  |  Price: £0.00  |  Track inventory: No
   */
  var LLZ_FREE_ASSEMBLY_THRESHOLD = 90000;   // £900 in pence — full cart total
  var LLZ_FREE_ASSEMBLY_ACTIVE    = false;
  var LLZ_FREE_ASSEMBLY_DISMISSED = false;
  var LLZ_FREE_ASSEMBLY_VID       = null;    // cached £0 variant ID

  var variantIdCache = {};

  function getVariantId(handle, callback) {
    if (variantIdCache[handle]) { callback(variantIdCache[handle]); return; }
    fetch('/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data && data.variants && data.variants[0]) {
          variantIdCache[handle] = data.variants[0].id;
          callback(data.variants[0].id);
        } else { callback(null); }
      })
      .catch(function() { callback(null); });
  }

  /* Fetches the FREE (£0) variant of Assembly Service — variant index 1.
   * Requires a 2nd variant on the Assembly Service product priced at £0.
   * Results cached so only one network request is made. */
  function llzGetFreeAssemblyVariantId(callback) {
    if (LLZ_FREE_ASSEMBLY_VID) { callback(LLZ_FREE_ASSEMBLY_VID); return; }
    fetch('/products/assembly-service.js')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var freeVariant = data && data.variants && data.variants[1]; // index 1 = £0 variant
        if (freeVariant) {
          LLZ_FREE_ASSEMBLY_VID = freeVariant.id;
          callback(freeVariant.id);
        } else {
          console.warn('[LLZ] Free assembly variant not found. Add a £0 variant to Assembly Service product.');
          callback(null);
        }
      })
      .catch(function() { callback(null); });
  }

  function prefetchVariantIds() {
    Object.keys(ADDON_PRODUCTS).forEach(function(key) {
      getVariantId(ADDON_PRODUCTS[key].handle, function() {});
    });
    llzGetFreeAssemblyVariantId(function() {}); // pre-cache £0 variant ID
  }

  var state = {
    basePrice    : 0,
    variantLabels: {},
    colour       : '',
    fabric       : '',
    size         : '',
    styling      : ''
  };

  function money(pence) {
    return '\u00a3' + (pence / 100).toFixed(2);
  }

  /* ─── Read base price ─────────────────────────────────────────────────── */
  function readBasePrice() {
    var el = document.querySelector('hdt-price.hdt-price .hdt-money') ||
             document.querySelector('.hdt-price .hdt-money') ||
             document.querySelector('.hdt-money');
    if (!el) return;
    var text = el.textContent.replace(/[^0-9.]/g, '').trim();
    if (text) state.basePrice = Math.round(parseFloat(text) * 100) || 0;
  }

  /* ─── Get selected bed size ───────────────────────────────────────────── */
  function getSelectedSize() {
    if (state.size) return state.size;
    var allRadios = document.querySelectorAll('input[type="radio"]:checked');
    var foundSize = '';
    allRadios.forEach(function(r) {
      var val = r.value || '';
      if (val.toLowerCase().indexOf('ft') !== -1 &&
          val.toLowerCase().indexOf('storage') === -1 &&
          r.name !== 'llz_mattress_size') {
        foundSize = val;
      }
    });
    return foundSize;
  }

  /* ─── Fabric detection ────────────────────────────────────────────────── */
  function getFabricFromKalles() {
    var optionWrappers = document.querySelectorAll(
      '[class*="variant"] [class*="option"], [class*="swatch-group"], ' +
      '[data-option-index], .hdt-variant-picker > div, [class*="product-option"]'
    );
    var fabricValue = null;
    optionWrappers.forEach(function(wrapper) {
      if ((wrapper.textContent || '').toLowerCase().indexOf('fabric') !== -1) {
        var checked = wrapper.querySelector('input[type="radio"]:checked');
        if (checked) fabricValue = checked.value;
      }
    });
    return fabricValue;
  }

  /* ─── Watch variant changes ───────────────────────────────────────────── */
  function bindVariantWatchers() {
    document.addEventListener('change', function(e) {
      var input = e.target;
      if (!input || input.type !== 'radio') return;
      // Skip all our custom addon/mattress/headboard-height radios
      if (input.name && (
        input.name.indexOf('properties[') !== -1 ||
        input.name === 'llz_mattress_type' ||
        input.name === 'llz_mattress_size' ||
        input.name === 'llz_headboard_height'
      )) return;

      var value   = input.value;
      var optName = getOptionName(input);
      state.variantLabels[optName] = value;

      if (isSizeOption(value, optName)) state.size = value;
      if (isFabricOption(input, optName, value)) {
        state.fabric = value;
        document.dispatchEvent(new CustomEvent('llz:fabric-changed', { detail: { fabric: value } }));
      }

      setTimeout(function() {
        readBasePrice();
        window.LLZ_updateSummary && window.LLZ_updateSummary();
      }, 200);
    });

    document.addEventListener('variant:change', function(e) {
      if (e.detail && e.detail.variant) {
        state.basePrice = e.detail.variant.price || 0;
        window.LLZ_updateSummary && window.LLZ_updateSummary();
      }
    });

    document.addEventListener('hdt:variant:change', function(e) {
      if (e.detail && e.detail.variant) {
        state.basePrice = e.detail.variant.price || 0;
        window.LLZ_updateSummary && window.LLZ_updateSummary();
      }
    });

    document.addEventListener('click', function(e) {
      var variantLabel = e.target.closest('[class*="swatch"], [class*="variant-btn"], [class*="option-btn"]');
      if (!variantLabel) return;
      setTimeout(function() {
        var fabricVal = getFabricFromKalles();
        if (fabricVal && fabricVal !== state.fabric) {
          state.fabric = fabricVal;
          document.dispatchEvent(new CustomEvent('llz:fabric-changed', { detail: { fabric: fabricVal } }));
        }
        readBasePrice();
        window.LLZ_updateSummary && window.LLZ_updateSummary();
      }, 100);
    });

    // Seed initial state
    document.querySelectorAll('input[type="radio"]:checked').forEach(function(input) {
      if (!input.name) return;
      if (input.name.indexOf('properties[') !== -1) return;
      if (input.name === 'llz_mattress_type' || input.name === 'llz_mattress_size') return;
      if (input.name === 'llz_headboard_height') return;
      var value   = input.value;
      var optName = getOptionName(input);
      state.variantLabels[optName] = value;
      if (isSizeOption(value, optName)) state.size = value;
      if (isFabricOption(input, optName, value)) state.fabric = value;
    });
  }

  function getOptionName(input) {
    var parent = input.closest('[data-option-name]');
    if (parent) return parent.getAttribute('data-option-name');
    var wrapper = input.closest('fieldset, [class*="option"], [class*="swatch-group"], div');
    if (wrapper) {
      var legend = wrapper.querySelector('legend, [class*="label"], [class*="title"], [class*="heading"]');
      if (legend) { var t = legend.textContent.replace(/:.*/,'').trim(); if (t) return t; }
    }
    return input.name || 'Option';
  }

  function isSizeOption(value, optName) {
    if (optName && optName.toLowerCase().indexOf('size') !== -1) return true;
    var v = value.toLowerCase();
    return v.indexOf('ft') !== -1 && v.indexOf('storage') === -1;
  }

  function isFabricOption(input, optName, value) {
    if (optName.toLowerCase().indexOf('fabric') !== -1) return true;
    var fabricNames = ['linen fabric','bouclé/teddy','boucle/teddy','soft naple velvet','plush/suede fabric','chenille fabric'];
    if (fabricNames.indexOf(value.toLowerCase()) !== -1) return true;
    var wrapper = input.closest('fieldset, [class*="option-group"], div');
    if (wrapper) {
      var text = wrapper.textContent.toLowerCase();
      if (text.indexOf('choose fabric') !== -1 || text.indexOf('fabric:') !== -1) return true;
    }
    return false;
  }

  /* ─── Watch addon card radio changes ─────────────────────────────────────
     Only watches properties[] radios (our custom addon inputs)           */
  function bindAddonWatchers() {
    document.addEventListener('change', function(e) {
      var input = e.target;
      if (!input || input.type !== 'radio') return;
      if (!input.name || input.name.indexOf('properties[') === -1) return;

      // Find parent addon row
      var row = input.closest('[data-addon]');
      if (!row) return;

      // Update card selected state
      row.querySelectorAll('.llz-addon-card').forEach(function(card) {
        card.classList.toggle('is-selected', card.contains(input) && input.checked);
      });

      /* Free assembly: dismiss on No, re-enable on Yes */
      if (input.name === 'properties[Assembly Service]') {
        var asmRow = document.querySelector('[data-addon="assembly"]');
        if (input.value === 'No' && LLZ_FREE_ASSEMBLY_ACTIVE) {
          LLZ_FREE_ASSEMBLY_ACTIVE    = false;
          LLZ_FREE_ASSEMBLY_DISMISSED = true;
          if (asmRow) {
            var orig = parseInt(asmRow.getAttribute('data-original-addon-price') || '0', 10);
            asmRow.setAttribute('data-addon-price', orig);
            var prEl = asmRow.querySelector('.llz-addon-card:last-child .llz-addon-card-price');
            if (prEl) prEl.textContent = '+ \u00a3' + (orig / 100).toFixed(2);
          }
          var bdg = document.getElementById('llz-free-assembly-badge');
          if (bdg) bdg.style.display = 'none';
        } else if (input.value !== 'No') {
          LLZ_FREE_ASSEMBLY_DISMISSED = false;
        }
      }

      window.LLZ_updateSummary && window.LLZ_updateSummary();
    });
  }

  function bindColourWatcher() {
    document.addEventListener('llz:colour-changed', function (e) {
      state.colour = e.detail.colour;
      window.LLZ_updateSummary && window.LLZ_updateSummary();
    });
  }

  /* ─── Watch button styling card changes ──────────────────────────────── */
  function bindStylingWatcher() {
    document.addEventListener('change', function(e) {
      var input = e.target;
      if (!input || input.type !== 'radio' || input.name !== 'llz_styling') return;

      var card  = input.closest('.llz-style-card');
      var label = card ? card.getAttribute('data-styling-label') : input.value;

      // Update selected visual state on all cards
      document.querySelectorAll('.llz-style-card').forEach(function(c) {
        c.classList.toggle('is-selected', c === card);
      });

      // Update the displayed selected name label
      var nameEl = document.getElementById('llz-styling-selected-name');
      if (nameEl) nameEl.textContent = label;

      // Update hidden property field so it submits with the form
      var propEl = document.getElementById('llz-styling-prop');
      if (propEl) propEl.value = label;

      // Store in state for summary box and cart injection
      state.styling = label;

      window.LLZ_updateSummary && window.LLZ_updateSummary();
    });

    // Seed initial styling state from whichever card starts checked on page load
    var checkedStyle = document.querySelector('input[name="llz_styling"]:checked');
    if (checkedStyle) {
      var card      = checkedStyle.closest('.llz-style-card');
      state.styling = card ? card.getAttribute('data-styling-label') : checkedStyle.value;
      var propEl    = document.getElementById('llz-styling-prop');
      if (propEl) propEl.value = state.styling;
    }

    // Equalise tile heights — run after images and fonts have loaded so
    // natural heights are accurate, then set all tiles to the tallest value.
    function equaliseStyleCardHeights() {
      var cards = document.querySelectorAll('.llz-style-card');
      if (!cards.length) return;
      // Reset to auto first so we measure natural height
      cards.forEach(function(c) { c.style.height = 'auto'; });
      var max = 0;
      cards.forEach(function(c) { max = Math.max(max, c.offsetHeight); });
      if (max > 0) {
        cards.forEach(function(c) { c.style.height = max + 'px'; });
      }
    }

    // Run at DOMContentLoaded timing, then again after images load
    equaliseStyleCardHeights();
    window.addEventListener('load', equaliseStyleCardHeights);
    // Also run after a short delay for late-rendering themes
    setTimeout(equaliseStyleCardHeights, 600);
  }

  /* ═══════════════════════════════════════════════════════════════════════
     DYNAMIC MATTRESS SYSTEM
     ─────────────────────────────────────────────────────────────────────
     Fetches /products/{handle}.js on page load.
     Builds LLZ_MATTRESS_DATA lookup: { typeKey → { label, minPrice,
       sizes: { sizeLabel → { id, price } } } }
     Renders type cards and size buttons into the DOM.
     No hardcoded IDs or prices — add/remove/reprice in Shopify admin
     and it reflects here automatically.
     ═══════════════════════════════════════════════════════════════════════ */

  var LLZ_MATTRESS_DATA   = {};   // built after fetch
  var LLZ_MATTRESS_READY  = false;
  var LLZ_ACTIVE_TYPE_KEY = null; // currently selected type key

  /* ─── Slugify a product option value into a safe key ─────────────────── */
  function llzSlug(str) {
    return str.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '');
  }

  /* ─── Fetch mattress product and build data map ───────────────────────── */
  /* ─── Fetch mattress COLLECTION and build data map ────────────────────────
   *
   *  Endpoint: /collections/{handle}/products.json?limit=250
   *
   *  Structure expected in Shopify:
   *    Mattresses collection
   *      └── Product: "Luxury Spring Memory Foam"   ← mattress TYPE = product title
   *            ├── Variant: "3ft Single"   £125     ← SIZE = variant title
   *            ├── Variant: "4ft Small Double" £155
   *            └── … etc
   *      └── Product: "Pure Orthopedic Spring"
   *      └── Product: "1000 Pocket"
   *      └── (any future product added here appears automatically)
   *
   *  To add a new mattress type → add a product to the collection.
   *  To add a size              → add a variant to that product.
   *  To change a price         → edit the variant price in Shopify.
   *  Zero code changes ever needed.
   * ─────────────────────────────────────────────────────────────────────── */
  function llzFetchMattressData(handle, callback) {
    var fetchUrl = '/collections/' + handle + '/products.json?limit=250';
    console.log('[LLZ Mattress] Fetching:', fetchUrl);
    fetch(fetchUrl)
      .then(function(r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function(json) {
        // Guard: if store is password-protected or handle is wrong,
        // Shopify returns HTML redirect instead of JSON
        if (!json || !json.products) {
          console.warn('[LLZ Mattress] Response had no .products — possible wrong handle or store is password protected. Response:', json);
          callback({});
          return;
        }
        var products = json.products || [];
        var data = {};

        products.forEach(function(product) {
          /*
           * product.title     → mattress type label shown to customer
           * variant.title     → size label (e.g. "3ft Single")
           * variant.id        → Shopify variant ID used for cart
           * variant.price     → STRING like "125.00" (pounds) — convert to pence
           */
          var typeLabel = (product.title || '').split('|')[0].trim();
          if (!typeLabel) return;

          var key      = llzSlug(typeLabel);
          var sizes    = {};
          var minPrice = Infinity;

          (product.variants || []).forEach(function(v) {
            if (v.available === false) return;           // skip sold-out sizes
            var sizeLabel = (v.title || '').trim();
            var pence     = Math.round(parseFloat(v.price) * 100);
            if (!sizeLabel || !v.id || isNaN(pence)) return;
            sizes[sizeLabel] = { id: v.id, price: pence };
            if (pence < minPrice) minPrice = pence;
          });

          if (!Object.keys(sizes).length) return;       // no available sizes — skip type

          data[key] = {
            label    : typeLabel,
            minPrice : minPrice === Infinity ? 0 : minPrice,
            sizes    : sizes
          };
        });

        LLZ_MATTRESS_DATA  = data;
        LLZ_MATTRESS_READY = true;
        callback(data);
      })
      .catch(function(err) {
        console.warn('[LLZ] Mattress collection fetch failed for "' + handle + '":', err);
        callback({});
      });
  }

  /* ─── Render type cards into #llz-mattress-types-container ─────────────── */
  function llzRenderMattressTypes(data) {
    var container = document.getElementById('llz-mattress-types-container');
    if (!container) return;

    var keys = Object.keys(data);
    if (!keys.length) {
      console.warn('[LLZ Mattress] No products returned. Check: (1) collection handle is correct, (2) products in collection have variants, (3) store is not password protected.');
      container.innerHTML = '<p style="color:#c00;font-size:13px">No mattress options found. (Check browser console for details.)</p>';
      return;
    }

    var html = '';
    keys.forEach(function(key, i) {
      var t       = data[key];
      var checked = i === 0 ? ' checked' : '';
      var sel     = i === 0 ? ' is-selected' : '';
      var fromStr = '\u00a3' + (t.minPrice / 100).toFixed(0);
      html += '<label class="llz-mtype-card' + sel + '" data-type="' + key + '">' +
                '<input type="radio" name="llz_mattress_type" value="' + key + '"' + checked + '>' +
                '<span class="llz-mtype-inner">' +
                  '<span class="llz-mtype-title">' + t.label + '</span>' +
                  '<span class="llz-mtype-price">from ' + fromStr + '</span>' +
                '</span>' +
              '</label>';
    });

    container.innerHTML = html;

    // Attach change listeners
    container.querySelectorAll('input[name="llz_mattress_type"]').forEach(function(input) {
      input.addEventListener('change', LLZ_mattressUpdate);
    });

    // Set initial active type
    LLZ_ACTIVE_TYPE_KEY = keys[0];
  }

  /* ─── Render size buttons for a given type key ────────────────────────── */
  function llzRenderMattressSizes(typeKey) {
    var container   = document.getElementById('llz-mattress-sizes-container');
    var sizeSection = document.getElementById('llz-mattress-size-section');
    if (!container || !LLZ_MATTRESS_DATA[typeKey]) return;

    var sizes = LLZ_MATTRESS_DATA[typeKey].sizes;
    var sizeKeys = Object.keys(sizes);
    if (!sizeKeys.length) return;

    var html = '';
    sizeKeys.forEach(function(sizeLabel, i) {
      var checked = i === 0 ? ' checked' : '';
      var sel     = i === 0 ? ' is-selected' : '';
      /* Abbreviate long labels for the button text */
      var shortLabel = sizeLabel
        .replace('Standard Double', 'Double')
        .replace('Small Double', 'Small')
        .replace('Super King', 'Super')
        .replace('King Size', 'King');
      html += '<label class="llz-msize-btn' + sel + '" data-size="' + sizeLabel + '">' +
                '<input type="radio" name="llz_mattress_size" value="' + sizeLabel + '"' + checked + '>' +
                '<span>' + shortLabel + '</span>' +
              '</label>';
    });

    container.innerHTML = html;
    if (sizeSection) sizeSection.style.display = '';

    // Attach change listeners
    container.querySelectorAll('input[name="llz_mattress_size"]').forEach(function(input) {
      input.addEventListener('change', LLZ_mattressUpdate);
    });
  }

  /* ─── Toggle expand panel (called from inline onchange on Yes/No) ──────── */
  window.LLZ_mattressToggle = function(isYes) {
    var expand  = document.getElementById('llz-mattress-expand');
    var noCard  = document.getElementById('llz-mattress-no');
    var yesCard = document.getElementById('llz-mattress-yes-card');
    var row     = document.querySelector('.llz-mattress-row');
    if (isYes) {
      expand.style.display = 'block';
      yesCard.classList.add('is-selected');
      noCard.classList.remove('is-selected');
      LLZ_mattressUpdate();
    } else {
      expand.style.display  = 'none';
      noCard.classList.add('is-selected');
      yesCard.classList.remove('is-selected');
      if (row) row.setAttribute('data-addon-price', '0');
      window.LLZ_updateSummary && window.LLZ_updateSummary();
    }
  };

  /* ─── Update hidden fields, summary line, and running total ─────────────── */
  window.LLZ_mattressUpdate = function() {
    var typeInput = document.querySelector('input[name="llz_mattress_type"]:checked');
    var sizeInput = document.querySelector('input[name="llz_mattress_size"]:checked');
    if (!typeInput) return;

    var typeKey = typeInput.value;

    // If type changed, re-render sizes for that type
    if (typeKey !== LLZ_ACTIVE_TYPE_KEY) {
      LLZ_ACTIVE_TYPE_KEY = typeKey;
      llzRenderMattressSizes(typeKey);
      // After re-render, re-query the (now first) size radio
      sizeInput = document.querySelector('input[name="llz_mattress_size"]:checked');
    }

    if (!sizeInput) return;

    var typeData = LLZ_MATTRESS_DATA[typeKey];
    if (!typeData) return;

    var sizeLabel = sizeInput.value;
    var variant   = typeData.sizes[sizeLabel];
    if (!variant) return;

    var typeLabel = typeData.label;
    var priceStr  = '\u00a3' + (variant.price / 100).toFixed(2);
    var fromStr   = '\u00a3' + (typeData.minPrice / 100).toFixed(0);

    // Update hidden state fields
    document.getElementById('llz-mattress-variant-id').value  = variant.id;
    document.getElementById('llz-mattress-price-pence').value = variant.price;
    document.getElementById('llz-mattress-type-prop').value   = typeLabel;
    document.getElementById('llz-mattress-size-prop').value   = sizeLabel;

    // Update summary line inside expand panel
    var selLabel = document.getElementById('llz-mattress-selection-label');
    var selPrice = document.getElementById('llz-mattress-selection-price');
    var sumLine  = document.getElementById('llz-mattress-summary-line');
    if (selLabel) selLabel.textContent = typeLabel + ' \u2014 ' + sizeLabel;
    if (selPrice) selPrice.textContent = priceStr;
    if (sumLine)  sumLine.style.display = '';

    // Update "Yes £X" button label
    var yesPriceEl = document.getElementById('llz-mattress-yes-price');
    if (yesPriceEl) yesPriceEl.textContent = priceStr;

    // Update the data-addon-price on the row for running total
    var row = document.querySelector('.llz-mattress-row');
    if (row) row.setAttribute('data-addon-price', variant.price);

    // Highlight selected type card
    document.querySelectorAll('.llz-mtype-card').forEach(function(c) {
      c.classList.toggle('is-selected', c.getAttribute('data-type') === typeKey);
    });

    // Highlight selected size button
    document.querySelectorAll('.llz-msize-btn').forEach(function(b) {
      b.classList.toggle('is-selected', b.getAttribute('data-size') === sizeLabel);
    });

    // Update "from £X" on the type card
    document.querySelectorAll('.llz-mtype-card').forEach(function(c) {
      if (c.getAttribute('data-type') === typeKey) {
        var priceEl = c.querySelector('.llz-mtype-price');
        if (priceEl) priceEl.textContent = 'from ' + fromStr;
      }
    });

    window.LLZ_updateSummary && window.LLZ_updateSummary();
  };

  /* ─── Entry point: fetch data then build UI ──────────────────────────────── */
  function llzInitMattress() {
    var expand = document.getElementById('llz-mattress-expand');
    if (!expand) return; // mattress addon not on this product

    var handle = expand.getAttribute('data-mattress-handle') || 'mattresses';

    llzFetchMattressData(handle, function(data) {
      llzRenderMattressTypes(data);
      var firstKey = Object.keys(data)[0];
      if (firstKey) {
        LLZ_ACTIVE_TYPE_KEY = firstKey;
        llzRenderMattressSizes(firstKey);
        LLZ_mattressUpdate();
      }
    });
  }

  /* ─── Get mattress state (used by cart injection + summary) ─────────────── */
  function getMattressState() {
    var mattressRadio = document.querySelector('input[name="properties[Mattress]"]:checked');
    var isYes = mattressRadio && mattressRadio.value.toLowerCase().indexOf('yes') !== -1;

    if (!isYes) return { isYes: false, variantId: null, price: 0, typeLabel: '', sizeLabel: '' };

    var vidEl   = document.getElementById('llz-mattress-variant-id');
    var priceEl = document.getElementById('llz-mattress-price-pence');
    var typeEl  = document.getElementById('llz-mattress-type-prop');
    var sizeEl  = document.getElementById('llz-mattress-size-prop');

    return {
      isYes     : true,
      variantId : vidEl   ? parseInt(vidEl.value, 10)   : null,
      price     : priceEl ? parseInt(priceEl.value, 10) : 0,
      typeLabel : typeEl  ? typeEl.value  : '',
      sizeLabel : sizeEl  ? sizeEl.value  : ''
    };
  }

  /* ─── Get headboard height state ─────────────────────────────────────── */
  function getHeadboardHeightState() {
    var input = document.querySelector('input[name="llz_headboard_height"]:checked');
    if (!input) return { isCustom: false, label: '54 inches', extra: 0 };
    var val   = input.value;
    var match = val.match(/(\d+) inches tall.+\(\+£(\d+)\)/);
    if (!match) return { isCustom: false, label: '54 inches', extra: 0 };
    return {
      isCustom : true,
      label    : match[1] + ' inches tall',
      extra    : parseInt(match[2], 10) * 100
    };
  }

  /* ─── Helper: is addon Yes? ──────────────────────────────────────────── */
  function isAddonYes(propName) {
    var el = document.querySelector('input[name="properties[' + propName + ']"]:checked');
    return el && el.value.toLowerCase().indexOf('yes') !== -1;
  }

  function getAddonPrice(addonDataAttr) {
    var row = document.querySelector('[data-addon="' + addonDataAttr + '"]');
    return row ? parseInt(row.getAttribute('data-addon-price'), 10) || 0 : 0;
  }

  /* --- llzCheckFreeAssembly(totalPence) ---
   * totalPence = bed + ottoman + mattress + headboard (full cart before assembly).
   * >= £900: auto Yes, zero price shown, show badge.
   * <  £900: revert to No, restore price.
   */
  function llzCheckFreeAssembly(totalPence) {
    var asmRow   = document.querySelector('[data-addon="assembly"]');
    var noRadio  = document.querySelector('input[name="properties[Assembly Service]"][value="No"]');
    var yesRadio = document.querySelector('input[name="properties[Assembly Service]"][value^="Yes"]');
    if (!asmRow || !noRadio || !yesRadio) return;

    var noCard    = noRadio.closest('label');
    var yesCard   = yesRadio.closest('label');
    var badge     = document.getElementById('llz-free-assembly-badge');
    var priceEl   = yesCard ? yesCard.querySelector('.llz-addon-card-price') : null;
    var origPrice = parseInt(asmRow.getAttribute('data-original-addon-price') || '0', 10);
    // Guard: if metafield outputs 0 (product price not set in Shopify admin),
    // fall back to 8000 pence (£80) so the button always shows the correct price.
    // The real fix is ensuring the Assembly Service product is priced at £80 in Shopify.
    if (origPrice === 0) origPrice = 8000;
    var qualifies = totalPence >= LLZ_FREE_ASSEMBLY_THRESHOLD;

    if (qualifies && !LLZ_FREE_ASSEMBLY_DISMISSED) {
      if (!LLZ_FREE_ASSEMBLY_ACTIVE) {
        LLZ_FREE_ASSEMBLY_ACTIVE = true;
        yesRadio.checked = true;
        noRadio.checked  = false;
        if (noCard)  noCard.classList.remove('is-selected');
        if (yesCard) yesCard.classList.add('is-selected');
        asmRow.setAttribute('data-addon-price', '0');
      }
      if (priceEl) priceEl.innerHTML = '<span style="color:#2a7a2a;font-weight:700">FREE</span>';
      if (badge)   badge.style.display = '';

    } else if (!qualifies && LLZ_FREE_ASSEMBLY_ACTIVE) {
      LLZ_FREE_ASSEMBLY_ACTIVE    = false;
      LLZ_FREE_ASSEMBLY_DISMISSED = false;
      noRadio.checked  = true;
      yesRadio.checked = false;
      if (noCard)  noCard.classList.add('is-selected');
      if (yesCard) yesCard.classList.remove('is-selected');
      asmRow.setAttribute('data-addon-price', origPrice);
      if (priceEl) priceEl.textContent = '+ \u00a3' + (origPrice / 100).toFixed(2);
      if (badge)   badge.style.display = 'none';
    }
  }

  /* ─── Summary update ─────────────────────────────────────────────────── */
  window.LLZ_updateSummary = function () {
    var SUMMARY_ROWS  = document.getElementById('llz-summary-rows');
    var SUMMARY_TOTAL = document.getElementById('llz-summary-total');
    if (!SUMMARY_ROWS || !SUMMARY_TOTAL) return;

    var rows  = '';
    var total = state.basePrice;

    // Variant selections (size, ottoman, fabric)
    // Skip any option whose NAME looks like a fabric/styling value — these are
    // Shopify variant option names (e.g. "Matching Fabric") that appear as a label
    // on products with button styling, causing a duplicate row. We already render
    // Choose Fabric and Button Styling as dedicated rows below.
    // Skip any variant option whose name matches a button styling value.
    // These are Shopify variant option names that appear as summary rows on
    // products with button styling — causing a duplicate "Button Styling" row.
    // Add any future styling option names here in lowercase.
    var SKIP_VARIANT_LABELS = [
      'matching fabric', 'matching fabric buttons',
      'crystal diamond', 'crystal diamond buttons'
    ];
    Object.keys(state.variantLabels).forEach(function (optName) {
      var val = state.variantLabels[optName];
      if (!val) return;
      if (SKIP_VARIANT_LABELS.indexOf(optName.toLowerCase().trim()) !== -1) return;
      rows += '<div class="llz-summary-row">' +
                '<span class="llz-summary-row-label">' + optName + '</span>' +
                '<span class="llz-summary-row-value">' + val + '</span>' +
              '</div>';
    });

    // Colour
    if (state.colour) {
      rows += '<div class="llz-summary-row">' +
                '<span class="llz-summary-row-label">Colour</span>' +
                '<span class="llz-summary-row-value">' + state.colour + '</span>' +
              '</div>';
    }

    // Button Styling — only rendered when llz-styling-wrapper exists on this product
    // No price uplift — all button styling options are included in the bed price.
    var stylingWrapper = document.getElementById('llz-styling-wrapper');
    if (stylingWrapper && state.styling) {
      rows += '<div class="llz-summary-row">' +
                '<span class="llz-summary-row-label">Button Styling</span>' +
                '<span class="llz-summary-row-value">' + state.styling + '</span>' +
              '</div>';
    }

    // Ottoman Storage Box
    var ottomanYes = isAddonYes('Ottoman Storage Box');
    var ottomanPrice = getAddonPrice('ottoman_box');
    if (ottomanYes) total += ottomanPrice;
    rows += '<div class="llz-summary-row">' +
              '<span class="llz-summary-row-label">Ottoman Storage Box</span>' +
              '<span class="llz-summary-row-value">' +
              (ottomanYes ? '<span class="llz-summary-yes">+ ' + money(ottomanPrice) + '</span>'
                          : '<span class="llz-summary-no">Not added</span>') +
              '</span></div>';

    // Mattress
    var m = getMattressState();
    if (m.isYes) {
      total += m.price;
      rows += '<div class="llz-summary-row">' +
                '<span class="llz-summary-row-label">' + m.sizeLabel + ' Mattress</span>' +
                '<span class="llz-summary-row-value llz-summary-yes">+ ' + money(m.price) + '</span>' +
              '</div>';
      if (m.typeLabel) {
        rows += '<div class="llz-summary-row">' +
                  '<span class="llz-summary-row-label" style="font-size:10px;opacity:0.65">' + m.typeLabel + '</span>' +
                  '<span class="llz-summary-row-value"></span>' +
                '</div>';
      }
    } else {
      rows += '<div class="llz-summary-row">' +
                '<span class="llz-summary-row-label">Mattress</span>' +
                '<span class="llz-summary-row-value llz-summary-no">Not added</span>' +
              '</div>';
    }

    // Headboard Height — only show if the UI block is present on this product
    var hhRow = document.querySelector('[data-addon="headboard_height"]');
    if (hhRow) {
      var hh = getHeadboardHeightState();
      if (hh.isCustom && hh.extra > 0) total += hh.extra;
      rows += '<div class="llz-summary-row">' +
                '<span class="llz-summary-row-label">Headboard Height</span>' +
                '<span class="llz-summary-row-value">' +
                hh.label +
                (hh.isCustom && hh.extra > 0
                  ? ' <span class="llz-summary-yes">+ ' + money(hh.extra) + '</span>'
                  : '') +
                '</span></div>';
    }

    // Split Headboard
    var headboardYes   = isAddonYes('Split Headboard');
    var headboardPrice = getAddonPrice('headboard');
    if (headboardYes) total += headboardPrice;
    rows += '<div class="llz-summary-row">' +
              '<span class="llz-summary-row-label">Split Headboard</span>' +
              '<span class="llz-summary-row-value">' +
              (headboardYes ? '<span class="llz-summary-yes">+ ' + money(headboardPrice) + '</span>'
                            : '<span class="llz-summary-no">Not added</span>') +
              '</span></div>';

    // Assembly Service — check full cart total (before assembly) against threshold
    llzCheckFreeAssembly(total);
    var assemblyYes   = isAddonYes('Assembly Service');
    var assemblyPrice = getAddonPrice('assembly');  // 0 when free
    if (assemblyYes) total += assemblyPrice;
    rows += '<div class="llz-summary-row">' +
              '<span class="llz-summary-row-label">Assembly Service</span>' +
              '<span class="llz-summary-row-value">' +
              (assemblyYes
                ? (LLZ_FREE_ASSEMBLY_ACTIVE
                    ? '<span style="color:#2a7a2a;font-weight:700">FREE</span>'
                    : '<span class="llz-summary-yes">+ ' + money(assemblyPrice) + '</span>')
                : '<span class="llz-summary-no">Not added</span>') +
              '</span></div>';

    SUMMARY_ROWS.innerHTML = rows ||
      '<div class="llz-summary-row llz-summary-placeholder"><span>Select your options above</span></div>';
    SUMMARY_TOTAL.textContent = money(total);
  };

  /* ─── Cart injection ─────────────────────────────────────────────────── */
  var cartSubmitting = false;

  function bindCartInjection() {
    var form = document.querySelector('form[action="/cart/add"]');
    if (!form) return;

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      if (cartSubmitting) return;
      cartSubmitting = true;

      var btn = form.querySelector('button[type="submit"], button.hdt-product-form__submit');
      if (btn) { btn.disabled = true; btn.style.opacity = '0.6'; }

      // Get bed variant ID
      var variantInput = form.querySelector('input[name="id"]');
      var bedVariantId = variantInput ? parseInt(variantInput.value, 10) : null;
      if (!bedVariantId) { form.submit(); return; }

      // Collect bed properties (exclude addon properties)
      var bedProperties = {};
      var formData = new FormData(form);
      formData.forEach(function(value, key) {
        if (key.indexOf('properties[') === -1) return;
        var propName = key.replace('properties[', '').replace(']', '');
        // Skip addon props — they go on their own line items
        var skip = ['Mattress','Ottoman Storage Box','Split Headboard','Assembly Service',
                    'Mattress Type','Mattress Size'];
        if (skip.indexOf(propName) !== -1) return;
        bedProperties[propName] = value;
      });

      // Inject Colour into bed properties if selected via swatch
      // state.colour is set by llz:colour-changed event from the colour swatch UI.
      // Without this, the colour never reaches the cart or order confirmation email.
      if (state.colour && !bedProperties['Colour']) {
        bedProperties['Colour'] = state.colour;
      }

      // Inject Button Styling into bed properties so it appears in cart and order emails.
      // state.styling is set by bindStylingWatcher on llz_styling radio change.
      if (state.styling && !bedProperties['Button Styling']) {
        bedProperties['Button Styling'] = state.styling;
      }

      // Build items array — bed first
      var items = [{ id: bedVariantId, quantity: 1, properties: bedProperties }];

      // Promises for variant ID lookups
      var promises = [];

      // Ottoman
      if (isAddonYes('Ottoman Storage Box')) {
        promises.push(new Promise(function(resolve) {
          getVariantId(ADDON_PRODUCTS.ottoman_box.handle, function(vid) {
            if (vid) items.push({ id: vid, quantity: 1, properties: {} });
            resolve();
          });
        }));
      }

      // Mattress — use direct variant ID
      var m = getMattressState();
      if (m.isYes && m.variantId) {
        items.push({
          id        : m.variantId,
          quantity  : 1,
          properties: { 'Type': m.typeLabel, 'Size': m.sizeLabel }
        });
      }

      // Headboard
      if (isAddonYes('Split Headboard')) {
        promises.push(new Promise(function(resolve) {
          getVariantId(ADDON_PRODUCTS.headboard.handle, function(vid) {
            if (vid) items.push({ id: vid, quantity: 1, properties: {} });
            resolve();
          });
        }));
      }

      // Assembly Service
      if (isAddonYes('Assembly Service')) {
        promises.push(new Promise(function(resolve) {
          if (LLZ_FREE_ASSEMBLY_ACTIVE) {
            /* FREE: add the £0 variant (variant index 1) of Assembly Service.
               No Shopify discount used. No discount tag on ANY cart item.
               Cart shows: Assembly Service £0 — clean, no strikethrough needed
               because it was never priced differently in this cart session.
               REQUIRES: a 2nd variant on Assembly Service product priced £0.00
               Title suggestion: "Free - Included (Order over £900)" */
            llzGetFreeAssemblyVariantId(function(freeVid) {
              if (freeVid) {
                items.push({ id: freeVid, quantity: 1, properties: { _note: 'Free on orders over \u00a3900' } });
              } else {
                /* Fallback: add paid variant if free variant not set up yet */
                getVariantId(ADDON_PRODUCTS.assembly.handle, function(vid) {
                  if (vid) items.push({ id: vid, quantity: 1, properties: {} });
                  resolve();
                });
                return;
              }
              resolve();
            });
          } else {
            /* PAID: add normal £80 variant */
            getVariantId(ADDON_PRODUCTS.assembly.handle, function(vid) {
              if (vid) items.push({ id: vid, quantity: 1, properties: {} });
              resolve();
            });
          }
        }));
      }

      Promise.all(promises).then(function() {
        fetch('/cart/add.js', {
          method : 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body   : JSON.stringify({ items: items })
        })
        .then(function() { window.location.href = '/cart'; })
        .catch(function(err) {
          console.error('Cart error:', err);
          cartSubmitting = false;
          if (btn) { btn.disabled = false; btn.style.opacity = '1'; }
        });
      });

    }, true);
  }

  /* ─── Init ────────────────────────────────────────────────────────────── */
  function init() {
    prefetchVariantIds();
    readBasePrice();
    bindVariantWatchers();
    bindAddonWatchers();
    bindColourWatcher();
    bindStylingWatcher();
    bindCartInjection();
    llzInitMattress();          // ← dynamic mattress fetch + UI build
    window.LLZ_updateSummary();

    setTimeout(function() {
      var fabricVal = getFabricFromKalles();
      if (fabricVal) {
        state.fabric = fabricVal;
        document.dispatchEvent(new CustomEvent('llz:fabric-changed', { detail: { fabric: fabricVal } }));
      }
      readBasePrice();

      // Fix Assembly Service "Yes" button price label if metafield outputted 0.
      // Reads data-original-addon-price; if 0 or missing, corrects to £80.
      (function fixAssemblyPriceLabel() {
        var asmRow = document.querySelector('[data-addon="assembly"]');
        if (!asmRow) return;
        var stored = parseInt(asmRow.getAttribute('data-original-addon-price') || '0', 10);
        if (stored === 0) {
          // Metafield price missing — patch both attributes to £80 (8000p)
          asmRow.setAttribute('data-addon-price', '8000');
          asmRow.setAttribute('data-original-addon-price', '8000');
        }
        // Always sync the visible Yes button label to match stored/corrected price
        var finalPrice = parseInt(asmRow.getAttribute('data-original-addon-price'), 10) || 8000;
        var yesCard    = asmRow.querySelector('.llz-addon-card:last-child');
        var priceEl    = yesCard ? yesCard.querySelector('.llz-addon-card-price') : null;
        if (priceEl && !LLZ_FREE_ASSEMBLY_ACTIVE) {
          priceEl.textContent = '+ £' + (finalPrice / 100).toFixed(2);
        }
      })();

      window.LLZ_updateSummary();
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 100);
  }

})();
